import { Injectable } from "@angular/core";
import { TimeagoIntl } from "ngx-timeago";
import { LocalStorage } from "./localstorage.helper";
import { strings as englishStrings } from 'ngx-timeago/language-strings/en';
import { strings as arabicStrings } from 'ngx-timeago/language-strings/ar';

@Injectable()
export class MyIntl extends TimeagoIntl {
    constructor() {
        super();
        const lang = LocalStorage.get('lang') || 'en';
        this.strings = lang === 'ar' ? arabicStrings : englishStrings;

        // Optional override of "seconds" message
        this.strings.seconds = lang === 'ar' ? 'الآن' : 'Now';

        this.changes.next();
    }
}
